
export const MenuList = ({ 
    authorized, 
    otherUser, 
    closeMenu, 
    deleteMethod,
    onEdit 
}) => {
    return (
        <div className="menu-list">
            <button
                className="comm-menu-btn tr-btn"
                onClick={closeMenu}
            >
                Close
            </button>
            {authorized &&
                <button
                    className="comm-menu-btn tr-btn"
                    onClick={onEdit}
                >
                    Edit 
                </button>
            }
            {authorized &&
                <button
                    className="comm-menu-btn tr-btn"
                    onClick={deleteMethod}
                >
                    Delete 
                </button>
            }
            {otherUser &&
                <button className="comm-menu-btn tr-btn">Report</button>
            }
        </div>
    )
}